module.exports = __webpack_public_path__ + "img/Ident-4.4475db7b.png";